import { useQueryClient } from "@tanstack/react-query"

export function useArticulosInvalidation() {
  const queryClient = useQueryClient()

  const deleteQueryInfintyArticulos = () => {
    queryClient.removeQueries({
      queryKey: ["getArticulosByFilter"],
      exact: false,
    })
  }

  const updateAllArticulosQueries = () => {
    queryClient.invalidateQueries({
      queryKey: ["getArticulosByFilter"],
      exact: false,
    })
  }

  return {
    deleteQueryInfintyArticulos,
    updateAllArticulosQueries,
  }
}
